import { TodayContentLegacyPage } from './TodayContentLegacyPage';

export const todayContentLegacyRouter = {
  '/@/todays/:today_id': TodayContentLegacyPage,
};
